import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';

// eslint-disable-next-line import/prefer-default-export
export function goToAlerts(ownProps) {
  return () => {
    const { selfClose } = ownProps;
    history.push(paths.ALERTS);
    selfClose();
  };
}
